import { Button, CircularProgress, buttonClasses, useTheme } from '@mui/material'
import { type ReactNode } from 'react'

import { PhxIcon } from '@salsita-ai/platform-project-sdk/ui'

export const SubmitButton = (props: { isPending: boolean; title: ReactNode; formId: string }) => {
  const { isPending, title, formId } = props

  const theme = useTheme()

  return (
    <Button
      form={formId}
      type="submit"
      variant="contained"
      disabled={isPending}
      startIcon={
        isPending ? (
          <CircularProgress size={20} sx={{ color: theme.palette.action.disabled }} />
        ) : (
          <PhxIcon name="PaperPlaneTilt" />
        )
      }
      sx={{
        // Fix for the button changing width when disabled
        [`.${buttonClasses.startIcon}`]: {
          marginInlineStart: 'auto',
        },
      }}
    >
      {title}
    </Button>
  )
}
